/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuFilterLocation_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterDeliveryOptions_viewer$ref: FragmentReference;
export type SbSharedRefineMenuFilterDeliveryOptions_viewer = {|
  +isDeliveryOptionsDisabled: ?boolean,
  +$fragmentRefs: SbSharedRefineMenuFilterLocation_viewer$ref,
  +$refType: SbSharedRefineMenuFilterDeliveryOptions_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isDeliveryOptionsDisabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterLocation_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '52f870be18274b0d0153a7563b029072';
module.exports = node;
